import { render } from "./TheRoleMenu.vue?vue&type=template&id=39cb4add"
import script from "./TheRoleMenu.vue?vue&type=script&lang=js"
export * from "./TheRoleMenu.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__